/*
*/

import HarnessUser from "../components/HarnessUser/HarnessUser";
import Navbar from "../components/NavBar/Navbar"
import SideNavBar from "../components/NavBar/SideBar"

const HarnessUserPage = () =>{
    return (
        <div style={{ display: 'flex', width:'100% !important', position: 'fixed'}}>
            <SideNavBar />
            <div style={{  flex: 1, display: 'flex', flexDirection: 'column', }}>
                <div className="plt-page-nav">
                    <Navbar title="Harness User List"/>
                </div>
                <HarnessUser/>
            </div>
        </div>
    );
}

export default HarnessUserPage;

